// CONTRACT:C4-DESIGN-TOKENS.1.0
/** Documented safe-default fallback values for every semantic slot. When a token is missing
 *  from the active theme the resolver raises ErrMissingToken AND can surface this documented
 *  default so nothing renders invisible (transparent/undefined). These defaults are visible,
 *  type-correct values — never empty strings. */

import { SLOT_TYPES } from "./slots.ts";
import { APP6_AFFILIATION_COLORS } from "./status.ts";

/** A visible default per slot type — guarantees the resolver never yields invisible output. */
const DEFAULT_BY_TYPE: Readonly<Record<string, string>> = Object.freeze({
  // Magenta is intentionally loud: a default that draws attention to a missing token.
  color: "#FF00FF",
  length: "0px",
  fontSize: "16px",
  fontFamily: "system-ui, sans-serif",
  duration: "200ms",
  easing: "ease",
});

/** The documented safe default for a given slot key. Status slots fall back to their
 *  canonical APP-6 affiliation color so affiliation never renders as the loud magenta. */
export function safeDefaultFor(key: string): string {
  if (key === "status-hostile") return APP6_AFFILIATION_COLORS.hostile;
  if (key === "status-friendly") return APP6_AFFILIATION_COLORS.friendly;
  if (key === "status-neutral") return APP6_AFFILIATION_COLORS.neutral;
  if (key === "status-unknown") return APP6_AFFILIATION_COLORS.unknown;
  if (key === "status-pending") return APP6_AFFILIATION_COLORS.pending;
  const type = SLOT_TYPES[key];
  // Unknown (non-slot) keys still get a loud, visible fallback rather than nothing.
  return type ? DEFAULT_BY_TYPE[type] : DEFAULT_BY_TYPE.color;
}
